export const ADD_OVERLAY_ZONE_OBJECTS = 'ADD_OVERLAY_ZONE_OBJECTS';
export const REMOVE_OVERLAY_ZONE_OBJECT = 'REMOVE_OVERLAY_ZONE_OBJECT';
export const ADD_OVERLAY_TO_STORE = 'ADD_OVERLAY_TO_STORE';
export const UPDATE_DRAWN_OVERLAY_OBJECTS = 'UPDATE_DRAWN_OVERLAY_OBJECTS';
export const UPDATE_EDIT_OVERLAY_OBJECT = 'UPDATE_EDIT_OVERLAY_OBJECT';
export const RESET_REDUX_STATES = 'RESET_REDUX_STATES';
